import axios from 'axios';

/**
 * 端末情報取得API
 * @param {number|string} termId 端末ID
 * @returns {?object} レスポンス情報(端末情報)
 */
export async function getTerminalAPI(termId) {
  try {
    const url = `/api/Terminals/${termId}`;
    return axios.get(url);
  } catch (error) {
    console.error('getTerminalAPI', error);
  }
}

/**
 * 端末登録API
 * @param {number|string} termId 端末ID
 * @param {string} serverUrl サーバURL
 * @returns {?object} レスポンス情報(端末情報)
 */
export async function postTerminalAPI(termId, serverUrl) {
  try {
    const url = serverUrl + '/api/Terminals';
    const headers = { 'Content-Type': 'application/json' };
    return axios.post(url, { terminalId: termId.toString() }, { headers: headers });
  } catch (error) {
    console.error('postTerminalAPI', error);
  }
}

/**
 * ユーザ認証API
 * @param {string} userId ユーザID
 * @param {string} password パスワード
 * @returns {?object} レスポンス情報(ユーザ情報)
 */
export async function authUserAPI(userId, password) {
  try {
    const url = '/api/AuthUser';
    const data = { userId: userId, password: password };
    return axios.post(url, data);
  } catch (error) {
    console.error('authUserAPI', error);
  }
}

/**
 * 変換情報取得API
 * @returns {?object} レスポンス情報(変換情報配列)
 */
export async function getConvertsAPI() {
  try {
    const url = '/api/Converts';
    return axios.get(url);
  } catch (error) {
    console.error('getConvertsAPI', error);
  }
}

/**
 * 読取情報取得API
 * @returns {?object} レスポンス情報(読取情報配列(details:明細付き))
 */
export async function getReadsAPI() {
  try {
    const url = '/api/Reads';
    return axios.get(url);
  } catch (error) {
    console.error('getReadsAPI', error);
  }
}

/**
 * ログイン用読取情報取得API
 * @returns {?object} レスポンス情報(読取情報配列(details:明細付き))
 */
export async function getReadLoginAPI() {
  try {
    const url = '/api/Reads/login';
    return axios.get(url);
  } catch (error) {
    console.error('getReadLoginAPI', error);
  }
}

/**
 * 取込情報取得API
 * @returns {?object} レスポンス情報(取込情報配列(details:明細付き))
 */
export async function getInputsAPI() {
  try {
    const url = '/api/Inputs';
    return axios.get(url);
  } catch (error) {
    console.error('getInputsAPI', error);
  }
}

/**
 * バーコード情報取得API
 * @returns {?object} レスポンス情報(バーコード情報配列(details:明細付き))
 */
export async function getBarcodesAPI() {
  try {
    const url = '/api/Barcodes';
    return axios.get(url);
  } catch (error) {
    console.error('getBarcodesAPI', error);
  }
}

/**
 * ログイン用バーコード情報取得API
 * @returns {?object} レスポンス情報(バーコード情報配列(details:明細付き))
 */
export async function getBarcodesLoginAPI() {
  try {
    const url = '/api/Barcodes/login';
    return axios.get(url);
  } catch (error) {
    console.error('getBarcodesLoginAPI', error);
  }
}

/**
 * 照合情報取得API
 * @returns {?object} レスポンス情報(照合情報配列(details:明細付き))
 */
export async function getComparesAPI() {
  try {
    const url = '/api/Compares';
    return axios.get(url);
  } catch (error) {
    console.error('getComparesAPI', error);
  }
}

/**
 * 照合予定情報リスト取得API
 * @param {number|string} readId 読取ID
 * @param {number|string} inputId 取込ID
 * @returns {?object} レスポンス情報(照合予定情報配列)
 */
export async function getCompareOrderListAPI(readId, inputId) {
  try {
    const url = '/api/CompareOrder';
    return axios.get(url, { params: { readId: readId?.toString(), inputId: inputId?.toString() } });
  } catch (error) {
    console.error('getCompareOrderListAPI', error);
    return null;
  }
}

/**
 * 照合予定情報取得API
 * @param {number|string} compareOrderNo 照合予定NO
 * @returns {?object} レスポンス情報(照合予定情報(details:明細付き))
 */
export async function getCompareOrderAPI(compareOrderNo) {
  try {
    const url = `/api/CompareOrder/${compareOrderNo}`;
    return axios.get(url);
  } catch (error) {
    console.error('getCompareOrderAPI', error);
  }
}

/**
 * 照合予定情報登録API
 * @param {!object} data 登録照合予定情報
 * @returns {?object} レスポンス情報(照合予定情報)
 */
export async function postCompareOrderAPI(data) {
  try {
    const url = '/api/CompareOrder/single';
    return axios.post(url, data);
  } catch (error) {
    console.error('postCompareOrderAPI', error);
  }
}

/**
 *照合予定情報登録API(取込)
 * @param {object[]} data 登録照合予定情報配列
 * @returns {?object} レスポンス情報(照合予定情報配列)
 */
export async function postCompeareOrderInputAPI(data) {
  try {
    const url = '/api/CompareOrder/input';
    return axios.post(url, data);
  } catch (error) {
    console.error('postCoreareOrderInputAPI', error);
  }
}

/**
 * 照合予定情報重複確認API
 * @param {!object} data 照合予定情報
 * @returns {?object} レスポンス情報(重複照合予定情報(compareOrderNo=0:重複無し))
 */
export async function postCompareOrderDuplicateAPI(data) {
  try {
    const url = '/api/CompareOrder/duplicate';
    return axios.post(url, data);
  } catch (error) {
    console.error('postCompareOrderDuplicateAPI', error);
  }
}

/**
 * 照合予定情報更新(完了)
 * @param {number|string} compareOrderNo 照合予定NO
 * @param {string} completeSts 完了ステータス
 * @returns {?object} レスポンス情報(照合予定情報(details:明細付き))
 */
export async function putCompareOrderCompleteAPI(compareOrderNo, completeSts) {
  try {
    const url = `/api/CompareOrder/${compareOrderNo}/${completeSts}`;
    return axios.put(url);
  } catch (error) {
    console.error('putCompareOrderCompleteAPI', error);
  }
}

/**
 * 照合予定情報削除
 * @param {number|string} compareOrderNo 照合予定NO
 * @returns {?object} レスポンス情報(照合予定情報(空データ))
 */
export async function deleteCompareOrderAPI(compareOrderNo) {
  try {
    const url = `/api/CompareResult/${compareOrderNo}`;
    return axios.delete(url);
  } catch (error) {
    console.error('deleteCompareOrderAPI', error);
  }
}

/**
 * 照合実績情報リスト取得API
 * @param {number|string} readId 読取ID
 * @returns {?object} レスポンス情報(照合実績情報配列)
 */
export async function getCompareResultListAPI(readId) {
  try {
    const url = '/api/CompareResult';
    return axios.get(url, { params: { readId: readId.toString() } });
  } catch (error) {
    console.error('getCompareResultListAPI', error);
  }
}

/**
 * 照合実績情報取得API
 * @param {number|string} compareOrderNo 照合予定NO
 * @param {number|string} compareOrderNo 照合実績NO
 * @returns {?object} レスポンス情報(照合実績情報(details:明細付き))
 */
export async function getCompareResultAPI(compareOrderNo, compareResultNo) {
  try {
    const url = `/api/CompareResult/${compareOrderNo}/${compareResultNo}`;
    return axios.get(url);
  } catch (error) {
    console.error('getCompareResultAPI', error);
  }
}

/**
 * 照合実績情報登録API
 * @param {!object} data 登録照合実績情報
 * @returns {?object} レスポンス情報(照合実績情報(details:明細付き))
 */
export async function postCompareResultAPI(data) {
  try {
    const url = '/api/CompareResult';
    return axios.post(url, data);
  } catch (error) {
    console.error('postCompareResultAPI', error);
  }
}

/**
 * 照合実績情報重複確認API
 * @param {!object} data 照合履歴情報
 * @returns {?object} レスポンス情報(重複照合予定情報(compareResultNo=0:重複無し))
 */
export async function postCompareResultDuplicateAPI(data) {
  try {
    const url = '/api/CompareResult/duplicate';
    return axios.post(url, data);
  } catch (error) {
    console.error('postCompareResultDuplicateAPI', error);
  }
}

/**
 * 読取実績情報登録API(読取)
 * @param {!object} data 登録読取実績情報
 * @returns {?object} レスポンス情報(照合実績情報(details:明細付き))
 */
export async function postReadResultAPI(data) {
  try {
    const url = '/api/CompareResult/read';
    return axios.post(url, data);
  } catch (error) {
    console.error('postReadResultAPI', error);
  }
}

/**
 * 照合実績情報登録API(欠品登録)
 * @param {number|string} compareOrderNo 照合予定NO
 * @param {number|string} compareResultNo 照合実績NO
 * @returns {?object} レスポンス情報(照合実績情報(details:明細付き))
 */
export async function putCompareResultShortAPI(compareOrderNo, compareResultNo) {
  try {
    const url = `/api/CompareResult/short/${compareOrderNo}/${compareResultNo}`;
    return axios.put(url);
  } catch (error) {
    console.error('putCompareResultShortAPI', error);
  }
}

/**
 * 照合実績情報更新API(強制完了)
 * @param {number|string} compareOrderNo 照合予定NO
 * @param {number|string} compareResultNo 照合実績NO
 * @returns {?object} レスポンス情報(照合実績情報(details:明細付き))
 */
export async function putCompareResultForceAPI(compareOrderNo, compareResultNo) {
  try {
    const url = `/api/CompareResult/${compareOrderNo}/${compareResultNo}`;
    return axios.put(url);
  } catch (error) {
    console.error('putCompareResultForceAPI', error);
  }
}

/**
 * 照合実績情報更新API(エラー解除)
 * @param {number|string} compareOrderNo 照合予定NO
 * @param {number|string} compareResultNo 照合実績NO
 * @returns {?object} レスポンス情報(照合実績情報(details:明細付き))
 */
export async function putCompareResultCancelAPI(compareOrderNo, compareResultNo) {
  try {
    const url = `/api/CompareResult/cancel/${compareOrderNo}/${compareResultNo}`;
    return axios.put(url);
  } catch (error) {
    console.error('putCompareResultCancelAPI', error);
  }
}

/**
 * 照合実績情報削除API
 * @param {number|string} readId 読取ID
 * @returns {?object} レスポンス情報(照合実績情報配列)
 */
export async function deleteCompareResultsAPI(readId) {
  try {
    const url = '/api/CompareResult';
    return axios.delete(url, { params: { readId: readId.toString() } });
  } catch (error) {
    console.error('deleteCompareResultsAPI', error);
  }
}

/**
 * 出力履歴情報リスト取得API
 * @returns {?object} レスポンス情報(出力履歴情報配列)
 */
export async function getExportHistoryListAPI() {
  try {
    const url = '/api/ExportHistory';
    return axios.get(url);
  } catch (error) {
    console.error('getExportHistoryListAPI', error);
  }
}

/**
 * 出力履歴情報取得API
 * @param {string} exportDtKey 出力日時キー
 * @returns {?object} レスポンス情報(CSVデータ配列)
 */
export async function getExportHistoryAPI(exportDtKey) {
  try {
    const url = `/api/ExportHistory/${exportDtKey}`;
    return axios.get(url, { responseType: 'arraybuffer' });
  } catch (error) {
    console.error('getExportHistoryAPI', error);
  }
}

/**
 * 出力履歴情報登録API
 * @param {!object} data 出力履歴情報{readId,compareId}
 * @returns {?object} レスポンス情報(CSVデータ配列)
 */
export async function postExportHistoryAPI(data) {
  try {
    const url = '/api/ExportHistory';
    return axios.post(url, data, { responseType: 'arraybuffer' });
  } catch (error) {
    console.error('postExportHistoryAPI', error);
  }
}

/**
 * OSSライセンス情報取得API
 * @returns OSSライセンス情報(OSSライセンス配列)
 */
export async function getOssLicenseAPI() {
  try {
    const url = '/api/OssLicenses';
    return axios.get(url);
  } catch (error) {
    console.error('getOssLicenseAPI', error);
  }
}

axios.interceptors.request.use(function (config) {
  if (typeof config.params === 'undefined') {
    config.params = {};
  }
  if (typeof config.params === 'object') {
    if (typeof URLSearchParams === 'function' && config.params instanceof URLSearchParams)
      config.params.append('_', Date.now());
    else config.params._ = Date.now();
  }
  return config;
});

axios.interceptors.response.use(
  function (response) {
    // 成功時の処理
    return response;
  },
  function (error) {
    // 失敗時の処理
    switch (error.response?.status) {
      case (400, 401, 403, 404):
        console.log(`APIサーバ接続に失敗しました(${error.response?.status})`);
        break;
      case 500:
        console.log('APIサーバ処理に失敗しました(500)');
        break;
      default:
        console.log(`APIサーバで不明なエラーが発生しました(${error.response?.status})`);
        break;
    }
    console.log(error);
    return Promise.reject(error);
  }
);
